import { render } from "./app-navigation.vue?vue&type=template&id=5f513a32&ts=true"
import script from "./app-navigation.vue?vue&type=script&lang=ts"
export * from "./app-navigation.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\src\\BusinessLuchs_CRM\\frontend-dispatcher\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__